import { mapActions, mapGetters } from 'vuex';
import { flatten, uniqBy } from 'lodash';
import collapsiblePanel from '@/components/collapsible-panel/collapsible-panel.vue';
import newsFeedItem from './news-feed-item/news-feed-item.vue';

export default {
  components: {
    collapsiblePanel,
    newsFeedItem,
  },
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },
    inOverlay: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: '',
    },
    numArticles: {
      type: Number,
      default: 3,
    },
    marketId: {
      type: Number,
      default: null,
    },
    source: {
      type: Array,
      default: null,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    collapsible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showAllArticles: this.inOverlay,
      feeds: [],
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile']),
    classModifiers() {
      return {
        'news-feed': true,
        'news-feed--collapsible': this.collapsible,
      };
    },
    contentClassModifiers() {
      return {
        'news-feed__content': true,
        'news-feed__content--no-more': !this.showMoreButton,
        [`news-feed__content--${this.theme}`]: this.theme,
      };
    },
    articles() {
      try {
        const articles = flatten(this.feeds.map(feed => feed.items));
        const articlesWithoutDuplicates = uniqBy(articles, 'id');
        return articlesWithoutDuplicates
          .sort((a, b) => parseInt(b.published, 10) - parseInt(a.published, 10));
      } catch (exc) {
        return [];
      }
    },
    items() {
      return (this.showAllArticles) ? this.articles : this.articles.slice(0, this.numArticles);
    },
    showMoreButton() {
      return !this.showAllArticles && this.numArticles <= this.articles.length;
    },
    showNewsFeed() {
      return (this.marketId) ? this.items.length > 0 : true;
    },
  },
  methods: {
    ...mapActions('popup', ['setGenericPopup']),
    ...mapActions('insight', ['getFeeds', 'getMarketFeeds']),
    setupFeeds() {
      /* if source is passed then feed is not loaded via api calls */
      if (this.source) {
        this.feeds = this.source;
      } else if (this.marketId) {
        this.getMarketFeeds(this.marketId)
          .then((data) => {
            this.feeds = data;
          });
      } else {
        this.getFeeds()
          .then((data) => {
            this.feeds = data;
          });
      }
    },
    loadMore(e) {
      e.stopPropagation();
      if (this.isLayoutDesktop) {
        this.setGenericPopup({
          name: 'news-feed',
          options: {
            marketId: this.marketId,
          },
        });
      } else {
        this.showAllArticles = true;
      }
    },
  },
  created() {
    this.setupFeeds();
  },
};



// WEBPACK FOOTER //
// ./src/components/home/home-old/news-feed/news-feed.js